import React from "react";

type SocialLink = {
  href: string;
  label: string;
  icon: React.ReactNode;
};

const socialLinks: SocialLink[] = [
  {
    href: "https://facebook.com",
    label: "Facebook",
    icon: (
      <svg
        width="24"
        height="24"
        fill="currentColor"
        className="hover:text-blue-600 transition-colors"
      >
        <path d="M22 12c0-5.522-4.477-10-10-10S2 6.478 2 12c0 5 3.657 9.127 8.438 9.877v-6.987h-2.54v-2.89h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.242 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.89h-2.33V21.877C18.343 21.127 22 17 22 12z" />
      </svg>
    ),
  },
  {
    href: "https://twitter.com",
    label: "Twitter",
    icon: (
      <svg
        width="24"
        height="24"
        fill="currentColor"
        className="hover:text-sky-400 transition-colors"
      >
        <path d="M22.46 5.924c-.793.352-1.645.59-2.54.698a4.48 4.48 0 0 0 1.963-2.475 8.94 8.94 0 0 1-2.828 1.082A4.48 4.48 0 0 0 11.07 9.03c0 .352.04.695.116 1.022C7.728 9.89 4.1 8.1 1.671 5.149a4.48 4.48 0 0 0-.606 2.254c0 1.555.792 2.927 2.002 3.732a4.48 4.48 0 0 1-2.03-.561v.057a4.48 4.48 0 0 0 3.594 4.393c-.193.052-.397.08-.607.08-.148 0-.292-.014-.432-.04a4.48 4.48 0 0 0 4.184 3.116A8.98 8.98 0 0 1 2 19.54a12.67 12.67 0 0 0 6.86 2.01c8.23 0 12.74-6.82 12.74-12.74 0-.194-.004-.388-.013-.58A9.1 9.1 0 0 0 24 4.59a8.94 8.94 0 0 1-2.54.698z" />
      </svg>
    ),
  },
  // Add more social links as needed
];

const Footer: React.FC = () => {
  return (
    <footer className="relative z-20 bg-gradient-to-tr from-base-300 via-base-200 to-base-100 text-base-content border-t-4 border-primary mt-16">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Logo & Social */}
        <div className="flex flex-col items-center md:items-start gap-4">
          <img src="/dhi.png" className="w-20 h-20 shadow-none" alt="logo" />
          <div className="font-bold text-lg tracking-wide">
            DIVHUBINTER POLRI
          </div>
          <div className="flex gap-3 mt-2">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                className="text-base-content/60 hover:text-primary transition-colors"
              >
                {link.icon}
              </a>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-2 text-sm text-base-content/70">
          <div className="font-semibold text-primary mb-2">KONTAK</div>
          <div>Jl. Trunojoyo 3 Mabes POLRI, Jakarta, Indonesia.</div>
          <div>
            Phone (Jakarta):{" "}
            <a
              href="tel:+62217393650"
              className="text-base-content hover:text-primary hover:underline transition-colors"
            >
              +6221 7393650
            </a>
          </div>
          <div>
            E-mail:{" "}
            <a
              href="mailto:ncb-jakarta@interpol.go.id"
              className="text-base-content hover:text-primary hover:underline transition-colors"
            >
              ncb-jakarta@interpol.go.id
            </a>
          </div>
        </div>

        {/* Profil Links */}
        <div className="flex flex-col gap-2 text-sm">
          <div className="font-semibold text-primary mb-2">PROFIL</div>
          <a
            href="/visi-misi"
            className="text-base-content/70 hover:text-primary transition-colors"
          >
            Visi dan Misi
          </a>
          <a
            href="/profil"
            className="text-base-content/70 hover:text-primary transition-colors"
          >
            Profil
          </a>
          <a
            href="/struktur-organisasi"
            className="text-base-content/70 hover:text-primary transition-colors"
          >
            Struktur Organisasi
          </a>
          <a
            href="/tugas-fungsi"
            className="text-base-content/70 hover:text-primary transition-colors"
          >
            Tugas dan Fungsi
          </a>
          <span className="text-base-content/70 hover:text-primary transition-colors cursor-pointer">
            Tim Koordinasi Interpol
          </span>
        </div>

        {/* Weblinks */}
        <div className="flex flex-col gap-2 text-sm">
          <div className="font-semibold text-primary mb-2">WEBLINKS</div>
          <a
            href="https://polri.go.id"
            className="text-base-content/70 hover:text-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            POLRI
          </a>
          <span className="text-base-content/70 hover:text-primary transition-colors cursor-pointer">
            DIVHUBINTER
          </span>
          <span className="text-base-content/70 hover:text-primary transition-colors cursor-pointer">
            Biro Misi Internasional
          </span>
          <a
            href="https://kemlu.go.id/portal/id"
            className="text-base-content/70 hover:text-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kementerian Luar Negeri
          </a>
          <a
            href="https://www.kemenkumham.go.id/"
            className="text-base-content/70 hover:text-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kementerian Hukum dan Hak Asasi Manusia
          </a>
          <a
            href="https://asean.org/"
            className="text-base-content/70 hover:text-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            ASEAN
          </a>
          <a
            href="http://www.aseanapol.org/"
            className="text-base-content/70 hover:text-primary transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            ASEANAPOL
          </a>
        </div>
      </div>
      <div className="border-t border-base-300 text-center py-4 text-xs text-base-content/60">
        &copy; {new Date().getFullYear()} DIVHUBINTER POLRI. All rights
        reserved.
      </div>
    </footer>
  );
};

export default Footer;
